// extracted by mini-css-extract-plugin
export default {"handleComponent":"Handle_handleComponent--t38","handleMainComponent":"Handle_handleMainComponent--HAu"};